import React, { useEffect, useState } from "react";
import { PiXFill } from "react-icons/pi";
import Input from "../../../../../components/common/inputs/Input";
import { Form, Formik } from "formik";
import { updateProductStockValidation } from "../../../../../utils/validation/updateProductStockValidation";
import Button from "../../../../../components/common/button/Button";
import { putApi } from "../../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../../utils/toastify-message/ToastifyMessage";

const { forwardRef, useRef, useImperativeHandle } = React;

const UpdateProductStockModal = forwardRef(({ reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [singleProduct, setSingleProduct] = useState(null);

  useImperativeHandle(ref, () => ({
    showModal(data) {
      setSingleProduct(data);
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const [variation, setVariation] = useState(null);

  useEffect(() => {
    if (singleProduct?.option) {
      setVariation(singleProduct.option?.variations[0]);
    }
  }, [singleProduct]);

  const handleVariation = (id) => {
    let selectedVar = singleProduct.option.variations.filter((item) => {
      return item?._id === id;
    });
    setVariation(selectedVar[0]);
  };

  const handleClose = () => {
    setVariation(null);
    setSingleProduct(null);
    setShowModal(false);
  };

  const formHandler = async (values, { resetForm }) => {
    const path = "admin/products/updateProductStock";
    const body = {
      productSku: singleProduct.sku,
      ...(variation ? { productVarSku: variation.sku } : {}),
      stock: Number(values.stock),
    };
    try {
      await putApi({ path, body });
      successMessage("موجودی محصول با موفقیت آپدیت شد.");
      resetForm();
      reGetData();
      handleClose();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] md:w-[760px] py-4 max-h-[400px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] md:mr-[-380px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>
            آپدیت موجودی {singleProduct?.name}
            {variation ? ` - ${variation?.value}` : ""}
          </h4>
          <PiXFill
            onClick={handleClose}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        {singleProduct ? (
          <Formik
            enableReinitialize
            initialValues={{
              stock: "",
            }}
            validationSchema={updateProductStockValidation}
            onSubmit={formHandler}
          >
            <Form>
              <div className="w-11/12 mx-auto py-8 w-full ">
                {singleProduct?.option ? (
                  <div className="flex gap-4 items-center flex-col md:flex-row text-sm md:text-base">
                    <div className="w-32">انتخاب ویژگی :</div>
                    <select
                      onChange={(e) => handleVariation(e.target.value)}
                      className="w-6/12 bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      {singleProduct?.option?.variations.map((item) => {
                        return <option value={item._id}>{item?.value}</option>;
                      })}
                    </select>
                  </div>
                ) : null}
                <div className="w-full px-4 mt-4 flex gap-4 items-center md:items-start flex-col md:flex-row">
                  <div className="flex gap-2 mt-3">
                    موجودی فعلی : {variation?.stock ?? singleProduct?.stock}
                  </div>
                  <p className="border w-11/12 mx-auto md:mx-1 md:w-auto md:h-12"></p>
                  <p className="mt-3">موجودی جدید : </p>
                  <Input
                    name={"stock"}
                    placeholder={"موجودی جدید"}
                    type="text"
                  />
                </div>
              </div>
              <div className="flex gap-2 justify-end w-full">
                <Button
                  onClick={handleClose}
                  text={"بازگشت"}
                  color={"primary"}
                  type="button"
                />
                <Button text={"تغییر موجودی"} color={"success"} />
              </div>
            </Form>
          </Formik>
        ) : null}
      </div>
    </>
  );
});
export default UpdateProductStockModal;
